import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyledTag, StyledAndTag, StyledOrTag } from './styled';
import { getRuleId } from '@utils/filter/ruleUtils';
import { Select } from 'antd';
import { dimensionsListSelectorKeyValue } from '@store/common/dimensionList/selectors'; // need to use all dimensions
import { ERROR_DIMENSION_MAP } from '@src/utils/dimension/errorCodeHelper';
import { get } from 'lodash';

const AndTag = () => <StyledAndTag color="geekblue">AND</StyledAndTag>;
const OrTag = () => <StyledOrTag color="cyan">OR</StyledOrTag>;

const opOptions = [
  {
    value: 'eq',
    label: 'equals',
  },
  {
    value: 'not_eq',
    label: 'not equals',
  },
];

const Operator = ({ op, onChange }) => {
  return <Select value={op} bordered={false} options={opOptions} onChange={onChange} />;
};

function FilterBarAdvanced({ rules, removeRule, updateRule }) {
  const dispatch = useDispatch();
  const dimensionLookup = useSelector(dimensionsListSelectorKeyValue);

  const handleCloseFn = (rule) => () => {
    dispatch(removeRule(rule));
  };

  const ruleTag = (rule) => {
    const handleChange = (value) => {
      dispatch(updateRule(rule, value));
    };

    const dimensionKey = rule.field === 'TAG' ? rule.key : rule.field;

    // to display dimension table header, use
    // get(ERROR_DIMENSION_MAP, [dimensionKey, 'header'], '')
    const dimensionDisplayName =  get(dimensionLookup, dimensionKey, dimensionKey);

    return (
      <StyledTag key={getRuleId(rule)} color="blue" closable onClose={handleCloseFn(rule)}>
        {dimensionDisplayName}
        <Operator op={rule.op} onChange={handleChange}/>
        {rule.display}
      </StyledTag>
    );
  };

  const buildAndRule = (andRule) => {
    const orRules = andRule.map((orRule) => ruleTag(orRule));
    return orRules.reduce((acc, ele, idx) => [acc, <OrTag key={idx} />, ele]);
  };

  const buildRuleFragements = (rules) => {
    const andrules = rules.map((andRule) => buildAndRule(andRule));
    return andrules.reduce((acc, ele, idx) => [acc, <AndTag key={idx} />, ele]);
  };

  const ruleFragments = useMemo(() => buildRuleFragements(rules), [rules]);

  return <div>{ruleFragments}</div>;
}

export default FilterBarAdvanced;
